<kz-card
  *ngIf="pro"
  [fullWidth]="!miniCover"
  [ngClass]="{'kz-card--pro-mini-cover': miniCover, 'kz-card--pro-is-boxable': pro.isBoxable}">
  <div class="kz-card--pro-header">
    <div>
      <app-profile-preview-pro [professional]="pro" [size]="(miniCover) ? 'xs' : 'lg'"></app-profile-preview-pro>
      <div class="kz-card--favorites">
        <app-pro-favorite *ngIf="!miniCover" [size]="'small'" [pro]="pro" [favoriteId]="pro.favoriteId" [miniCover]="miniCover" (refresh)="refresh.emit(true)"></app-pro-favorite>
      </div>
      <p *ngIf="pro.description" class="kz-card--pro-header-description">{{ pro.description | shortDescription:300 }}<br/>
        <a [routerLink]="pro | proLink" i18n="@@pro.listing.see-more">See more</a>
      </p>
      <ul *ngIf="!miniCover" class="kz-card--infos-at-home">
        <li *ngIf="pro.coachAtHome"><kz-icons name="kaza"></kz-icons> <ng-container i18n="@@pro.header.cta.homeCoaching">Home coaching</ng-container></li>
        <li *ngIf="pro.coachDistance"><kz-icons name="laptop"></kz-icons> <ng-container i18n="@@pro.header.cta.onlineCoaching">Online coaching</ng-container></li>
      </ul>
    </div>
    <div class="kz-card--pro-footer">
      <a [routerLink]="pro | proLink"  kzButton buttonStyle="flat" [buttonContext]="pro.isBoxable ? 'box' : 'decorator'"><span i18n="@@pro.listing.learn-more">See the profile of {{pro.brand}}</span></a>
    </div>

  </div>
  <div class="kz-card--pro-media">
    <ng-container *ngIf="displayBestPrice">
      <ng-container *ngIf="(serviceWithBestPriceObs | async) as serviceBestWithPrice">
        <app-service-price [boxable]="pro.isBoxable" [service]="serviceBestWithPrice" [from]="true"></app-service-price>
      </ng-container>
    </ng-container>
    <app-pro-carousel [pro]="pro" [miniCover]="miniCover" [preloadImages]="preloadImages" [fetchPriority]="fetchPriority"></app-pro-carousel>
  </div>
</kz-card>
